export default class PostMessages {
  constructor(event, data) {
    this.payload = null;

    this.payloadBuilder(event, data);
  }

  payloadBuilder(event, data) {
    this.payload = {
      salt: process.env.VUE_APP_EVENT_SALT,
      event,
      data
    };
  }

  send() {
    try {
      window.parent.postMessage(this.payload, "*");
    } catch (e) {
      window.console.info("[ChatFoodWidget PostMessages]", e);
    }
  }
}
